import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import TrustSection from "./components/TrustSection";
import ServicesSection from "./components/ServicesSection";
import TestimonialsSection from "./components/TestimonialsSection";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";
import LeadForm from "./components/LeadForm";
import AdminDashboard from "./pages/AdminDashboard";
import LocationPage from "./pages/LocationPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";

const HomePage = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);

  const handleGetQuote = () => {
    setIsFormOpen(true);
  };

  return (
    <>
      <Header onGetQuote={handleGetQuote} />
      <main>
        <HeroSection onGetQuote={handleGetQuote} />
        <TrustSection />
        <ServicesSection onGetQuote={handleGetQuote} />
        <TestimonialsSection />
        <FAQSection />
        <CTASection onGetQuote={handleGetQuote} />
      </main>
      <Footer />
      <LeadForm isOpen={isFormOpen} onClose={() => setIsFormOpen(false)} />
    </>
  );
};

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <Toaster position="top-center" richColors />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/:slug" element={<LocationPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
